import { useState } from 'react'

const initialFilters = {
    is_evaluation_required: '1'
}

export const useTomPicturesFilters = () => {
    const [filters, setFilters] = useState(initialFilters)

    return {
        filters,
        setFilters
    }
}
